export default
{
    REQUESTED:      { text: 'Requested', value: 'REQUESTED', icon: 'tint' },
    SENT_TO_LAB:    { text: 'Sent to lab', value: 'SENT_TO_LAB', icon: 'send' },
    COMPLETED:      { text: 'Completed', value: 'COMPLETED', icon: 'check' }
}